import { create } from "@mui/material/styles/createTransitions";
import api from "../config/http-common";
import CommonUtil from "../Util/CommonUtils";

const buildQuery = (payload) => {
  let query =
    "?pageNumber=" + payload.pageNumber + "&pageSize=" + payload.pageSize;

  return query;
};

const getDayLightTime = (payload) => {
  return api
    .securedAxios()
    .post("/api/v4/web/day-light-savings" + buildQuery(payload), payload);
};

const createDayLightTime = (payload) => {
  return api.securedAxios().post("/api/v4/web/day-light-saving", payload);
};

const updateDayLightTime = (payload) => {
  return api
    .securedAxios()
    .put("/api/v4/web/day-light-savings/" + payload.id, payload);
};

const deleteDayLightTime = (id) => {
  return api.securedAxios().delete("/api/v4/web/day-light-savings/" + id);
};

const getDayLightTimeBySiteId = (siteId) => {
  return api.securedAxios().get("/api/v4/web/day-light-savings/" + siteId);
};

const DayLightTimeService = {
  getDayLightTime,
  createDayLightTime,
  deleteDayLightTime,
  updateDayLightTime,
  getDayLightTimeBySiteId,
};

export default DayLightTimeService;
